import { makeStyles } from 'tss-react/mui';
import { grey, red, green } from '@mui/material/colors';

export default makeStyles()(theme => ({
    root: {
        padding: theme.spacing(1)
    },
    itemQuantity: {
        fontWeight: 'bold',
        fontSize: 12
    },
    itemImage: {
        width: theme.spacing(8),
        height: theme.spacing(8),
        marginRight: theme.spacing(1),
        borderRadius: theme.spacing(1)
    },
    itemName: {
        fontWeight: 'bold'
    },
    itemDisabled: {
        opacity: 0.5,
        pointerEvents: 'none'
    },
    noItems: {
        color: grey[500],
        '& svg': {
            fontSize: theme.spacing(6)
        }
    },
    iconDelete: {
        color: red[300]
    },
    iconAdd: {
        color: green[300]
    },
    success: {
        color: theme.palette.success.main
    },
    products: {
        padding: theme.spacing(0, 1)
    },
    buttonPerception:{
        padding: '0px'
    }
}));